import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export const tooltip = {
  mounted(el, { value }) {
    if (!value) {
      return;
    }

    let config = value;
    if (typeof value !== 'object') {
      config = {
        content: value,
      }
    }

    tippy(el, config);
  },

  updated(el, { value }) {
    if (!value) {
      return;
    }

    let config = value;
    if (typeof value !== 'object') {
      config = {
        content: value,
      }
    }
    el._tippy.setProps(config);
  },

}